import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_H_C, ModuleFE_MouseInteractivity, mouseInteractivity_PopUp } from '@nu-art/thunderstorm-frontend/index';
import './PopUp_ProtocolDetails.scss';
import { ICONS } from '@app/styles';
import { Component_ProtocolDetails } from '../../components/next-steps/protocol-details/Component_ProtocolDetails.js';
import { ModuleFE_ProtocolInteraction } from '../../../_enum.js';
import { ModuleFE_RuntimeProtocol } from '@app/advisor-frontend';
import { ProtocolData } from '../../../_utils/ProtocolData/ProtocolData.js';
export class PopUp_ProtocolDetails extends ComponentSync {
    //######################### Static ##########################
    static show = (e, props) => {
        const rect = e.target.getBoundingClientRect();
        const xPos = rect.right - (rect.width / 2);
        const model = {
            content: () => _jsx(PopUp_ProtocolDetails, { ...props }),
            id: 'pop-up__protocol-details',
            modalPos: { x: 0, y: -1 },
            xAxisAnchor: 'left',
            yAxisAnchor: 'bottom',
            originPos: { x: xPos, y: rect.top },
            offset: { y: 10 },
            overlayClass: 'pop-up-overlay__protocol-details'
        };
        ModuleFE_MouseInteractivity.showContent(model);
    };
    //######################### Life Cycle ##########################
    //This component is responsible for listening on protocol interactions and switching context / closing itself based on the focused protocol
    __onProtocolInteraction = () => {
        const protocolId = ModuleFE_ProtocolInteraction.getFocusedProtocolId();
        if (!protocolId)
            return ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
        const protocol = ModuleFE_RuntimeProtocol.cache.unique(protocolId);
        this.setState({ protocolData: ProtocolData.createNew(protocol._id) });
    };
    deriveStateFromProps(nextProps, state) {
        state.protocolData = nextProps.protocolData;
        return state;
    }
    //######################### Render ##########################
    render() {
        return _jsxs(_Fragment, { children: [this.render_Header(), _jsx(Component_ProtocolDetails, { protocolData: this.state.protocolData })] });
    }
    render_Header = () => {
        return _jsxs(LL_H_C, { className: 'pop-up__protocol-details__header', children: ["Reasoning", _jsx(ICONS.advisor_avn_close.component, { onClick: this.props.closeDetails })] });
    };
}
//# sourceMappingURL=PopUp_ProtocolDetails.js.map